const EventEmitter = require('events');

import {newReq} from "@/core/request";

export class StatusMap extends EventEmitter {
    loading = false;

    constructor(obj) {
        super();
        this.match = null;
        this.defaultLabel = 0;
        this.teamLabels = [];
        this.alias = null;
        Object.assign(this, obj)
    }

    get title() {
        return this.alias || this.match
    }

    upsert(history = false) {
        return newReq('PATCH', 'classification/upsert', {history: history, statusMap: {...this}})
    }

    remove() {
        return newReq('PATCH', 'classification/remove', {_id: this._id})
    }

    updateDefault(history = false) {
        return newReq('PATCH', 'classification/updateDefaultLabel', {history: history, match: this.match, label: this.defaultLabel})
    }

    // create(deviceIds) {
    //     return newReq('POST', `employees/create`, {
    //         employee: JSON.parse(JSON.stringify(this)),
    //         deviceIds: deviceIds || []
    //     })
    // }
    // update(...keys) {
    //     const updateObj = JSON.parse(JSON.stringify(this))
    //     Object.keys(this).forEach(key => {
    //         if (!(keys || []).includes(key))
    //             delete updateObj[key];
    //     })
    //     return newReq('POST', `employees/update`, {...updateObj, _id: this._id})
    // }
}